import { render, staticRenderFns } from "./ForgotPasswordOld.vue?vue&type=template&id=2d996720&scoped=true&"
import script from "./ForgotPasswordOld.vue?vue&type=script&lang=ts&"
export * from "./ForgotPasswordOld.vue?vue&type=script&lang=ts&"
import style0 from "./ForgotPasswordOld.vue?vue&type=style&index=0&id=2d996720&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d996720",
  null
  
)

export default component.exports